var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlogan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.54 52.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#702180;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator",
    "data-name": "Text Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.27,
    cy: 26.27,
    r: 26.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.146,13.66a1.61,1.61,0,0,0-1.437.894l-2.922,5.919c-1.184.175-4.553.66-6.529.947a1.6,1.6,0,0,0-.888,2.733L20.1,28.759c-.2,1.179-.778,4.538-1.114,6.5a1.6,1.6,0,0,0,2.323,1.69l5.84-3.065,5.841,3.065a1.6,1.6,0,0,0,2.323-1.688c-.336-1.965-.913-5.326-1.114-6.5l4.728-4.606a1.6,1.6,0,0,0-.888-2.732l-6.53-.947c-.525-1.073-2.039-4.132-2.921-5.92A1.61,1.61,0,0,0,27.146,13.66Zm0,1.938,2.822,5.717a1.6,1.6,0,0,0,1.206.876l6.3.917-4.563,4.45a1.607,1.607,0,0,0-.461,1.418c.186,1.087.732,4.264,1.077,6.282l-5.642-2.966a1.612,1.612,0,0,0-1.489,0l-5.641,2.966c.345-2.014.89-5.2,1.077-6.282a1.607,1.607,0,0,0-.462-1.418l-4.563-4.45,6.305-.917a1.6,1.6,0,0,0,1.206-.876c.487-.989,1.916-3.881,2.822-5.717Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlogan);
export default __webpack_public_path__ + "static/media/slogan.6eb6f9f600571e8b46173f87b1403b45.svg";
export { ForwardRef as ReactComponent };